import { Component, HostListener, OnInit, signal } from '@angular/core';

@Component({
  selector: 'app-pwa-install-banner',
  templateUrl: './pwa-install-banner.html',
})
export class PwaInstallBannerComponent implements OnInit {
  protected showBanner = signal(false);
  protected isIos = signal(false);
  private deferredPrompt: BeforeInstallPromptEvent | null = null;

  ngOnInit(): void {
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isStandalone =
      ('standalone' in navigator) && (navigator as Navigator & { standalone: boolean }).standalone;

    if (isIos && !isStandalone && !this.wasDismissed()) {
      this.isIos.set(true);
      this.showBanner.set(true);
    }
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: Event): void {
    event.preventDefault();
    this.deferredPrompt = event as BeforeInstallPromptEvent;
    if (!this.wasDismissed()) {
      this.isIos.set(false);
      this.showBanner.set(true);
    }
  }

  protected async install(): Promise<void> {
    if (this.deferredPrompt) {
      await this.deferredPrompt.prompt();
      this.deferredPrompt = null;
    }
    this.dismiss();
  }

  protected dismiss(): void {
    sessionStorage.setItem('pwa-banner-dismissed', '1');
    this.showBanner.set(false);
  }

  private wasDismissed(): boolean {
    return sessionStorage.getItem('pwa-banner-dismissed') === '1';
  }
}

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}
